var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarLineDrawingThatCanBeUsedForSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#ffffff;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.819,282.016c-11.672-0.016-22.359,4.75-29.984,12.406c-7.656,7.625-12.422,18.313-12.422,29.984 c0.016,23.406,18.969,42.375,42.406,42.375c23.422,0,42.375-18.984,42.375-42.375c0.016-11.672-4.75-22.359-12.391-29.984 C383.163,286.766,372.475,282,360.819,282.016z M360.819,345.484c-11.672-0.016-21.078-9.453-21.094-21.078 c0-11.672,9.406-21.094,21.094-21.094c11.656,0,21.078,9.422,21.078,21.094C381.881,336.031,372.459,345.469,360.819,345.484z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.616,282.016c-11.688-0.016-22.344,4.75-29.984,12.406c-7.656,7.625-12.406,18.313-12.406,29.984 c0.016,23.391,18.953,42.375,42.391,42.375c23.422,0,42.391-18.969,42.391-42.375C169.006,300.953,150.022,282.016,126.616,282.016 z M126.616,345.484c-11.672-0.016-21.063-9.453-21.078-21.078c0-11.672,9.406-21.094,21.078-21.094 c11.656,0.016,21.078,9.422,21.094,21.094C147.694,336.031,138.256,345.469,126.616,345.484z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.976,226.172c-3.25-3.781-7.984-5.984-12.953-5.984h-104.11c-6.547,0-12.719-3.016-16.734-8.156 l-45.875-58.656c-4.031-5.141-10.203-8.156-16.734-8.156H145.334c-7.609,0-14.625,4.078-18.422,10.656l-36.953,64.313H16.991 c-5.016,0-9.797,2.219-13.016,6.063s-4.594,8.938-3.719,13.859l6.969,64.5c1.172,10.766,10.234,18.953,21.078,18.969l47.719,0.109 v-14.984l-47.672-0.109c-3.203-0.016-5.875-2.406-6.219-5.594l-7.125-65.484l0.453-1.641l1.531-0.688h72.969 c5.375,0,10.313-2.875,13.016-7.531l36.938-64.297c1.109-1.953,3.188-3.141,5.422-3.141h166.234c1.891,0,3.75,0.891,4.922,2.391 l45.875,58.688c6.938,8.813,17.328,13.891,28.547,13.891h104.11l1.531,0.688l0.516,0.672l0.172-0.297l-17.625,68.688 c-0.672,2.766-3.188,4.703-6.063,4.703l-62.172-0.125V324.5l62.141,0.141c9.734,0,18.203-6.563,20.625-15.984l17.641-68.734 C512.569,235,511.194,229.969,507.976,226.172z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.209,323.891 310.225,324.281 310.225,309.297 177.209,308.922 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLineDrawingThatCanBeUsedForSvgrepoCom);
export default __webpack_public_path__ + "static/media/car-line-drawing-that-can-be-used-for-svgrepo-com.8c65e047b3ca88ef7fa818979040c3a5.svg";
export { ForwardRef as ReactComponent };